import {IEventData} from 'coreClasses/events/IEvents';
import AbstractPriceModel from 'coreClasses/product/AbstractPriceModel';
import VariantModel from 'coreClasses/product/VariantModel';

/**
 * Represents ProductItemEvent
 */
export default class ProductItemEvent {
	public item_name: string;
	public item_id: string;
	public variation_id?: string;
	public price: number; // min price
	public discount: number; // amount of discount
	public item_brand: string; // brand id
	public item_variant: string; // color description
	public item_list_id: string; // category id (may be different from product's category id)
	public index: number; // position in the list if there are many items
	public season: string;
	public price_type: 'FP' | 'MD';
	public quantity: number;
	public cavallino: boolean; // true if productTag === 'cavallino'
	public category_id: string;
	public category_name: string;

	/**
	 * @constructor
	 * @param {IEventData} data - event data
	 */
	constructor(data: IEventData) {
		const product: VariantModel = data.product;
		const explicitPriceModel: AbstractPriceModel = data.priceModel;
		const index = data.index || 0;
		const quantity = data.quantity || 1;
		const productCategoriesIds: string[] = data.productCategoriesIds;
		const source = data.source;

		const productPriceModel = product.getPriceModel();
		const priceModel = explicitPriceModel ? explicitPriceModel : productPriceModel;

		const isSalesPriceBookApplied = priceModel.isSalesPriceBookApplied();
		const minPrice = priceModel.getMinPrice().value;
		const maxPrice = priceModel.getMaxPrice().value;
		const discount = maxPrice - minPrice;

		this.item_name = product.getName();
		this.item_id = product.getVariationGroupId(product.getVariationValues());
		this.price = Math.floor(minPrice);
		this.discount = Math.floor(discount);
		this.item_brand = product.getBrand();
		this.item_variant = product.getColorDescription();
		this.index = index;
		this.quantity = quantity;
		this.season = product.getSeason();
		this.price_type = isSalesPriceBookApplied ? 'MD' : 'FP';
		this.item_list_id = source;
		this.category_id = data.eventSourceCategoryId;
		this.category_name = data.eventSourceCategoryName;
		this.variation_id = product.getProductId();

		if (productCategoriesIds) {
			productCategoriesIds?.forEach((categoryId, i) => {
				const previousCategoryId = i > 0 ? productCategoriesIds[i - 1] : null;
				const isHierarchical = previousCategoryId && categoryId.startsWith(`${previousCategoryId}-`);
				const prefixLength = isHierarchical ? previousCategoryId.length + 1 : 0;
				this[`item_category${i === 0 ? '' : i + 1}`] = categoryId.substring(prefixLength);
			});
		}
	}
}
